import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=7ef21e7b&scoped=true";
import script from "./upload-image.vue?vue&type=script&lang=js";
export * from "./upload-image.vue?vue&type=script&lang=js";
import style0 from "./upload-image.vue?vue&type=style&index=0&id=7ef21e7b&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "7ef21e7b", null);
export default component.exports;